'use client';

import { useEffect, useState } from 'react';
import dynamic from 'next/dynamic';

export default function Page() {
  // const [widgetControll, setWidgetControll] = useState(false);

  // useEffect(() => {
  //   if (widgetControll) {
  //     localStorage.setItem('hideWidget', 'true');
  //   } else {
  //     localStorage.setItem('hideWidget', 'false');
  //   }
  // }, [widgetControll]);

  const Welcome = dynamic(() => import('./welcome'), { ssr: false });

  return <Welcome />;
}
